//add correct Spanish translation when we support Spanish
export const DentalText = {
    dentalTitle: {
        english: 'Dental insurance',
        spanish: 'Dental insurance',
    },
    claimsTitle: {
        english: 'Most recent claims',
        spanish: 'Most recent claims',
    },
    coveredServicesTitle: {
        english: 'Covered services',
        spanish: 'Covered services',
    },
    deductiblesTitle: {
        english: 'Deductibles and coinsurance',
        spanish: 'Deductibles and coinsurance',
    },
    dropdownText: {
        english: 'Select a member',
        spanish: 'Select a member',
    },
    effectiveDateText: {
        english: 'Effective date',
        spanish: 'Effective date',
    },
    terminationDateText: {
        english: 'Term date',
        spanish: 'Term date',
    },
    dateOfBirthText: {
        english: 'Date of birth',
        spanish: 'Date of birth',
    },
    coveredServicesText: {
        english: 'Covered services',
        spanish: 'Covered services',
    },
    deductibleText: {
        english: 'Deductibles and coinsurance',
        spanish: 'Deductibles and coinsurance',
    },
    claimsText: {
        english: 'Claims',
        spanish: 'Claims',
    },
    backText: {
        english: 'Back',
        spanish: 'Back',
    },
    disclaimerText1: {
        english: `The summary provided below is based on processed claims as of `,
        spanish: `The summary provided below is based on processed claims as of `,
    },
    disclaimerText2: {
        english: `. Future benefits will be applied in the order that claims are received and processed.`,
        spanish: `. Future benefits will be applied in the order that claims are received and processed.`,
    },
    deductibleAmountPaidText: {
        english: 'Amount paid towards deductible',
        spanish: 'Amount paid towards deductible',
    },
    deductiblesText: {
        english: 'deductibles',
        spanish: 'deductibles',
    },
    coinsuranceText: {
        english: 'coinsurance',
        spanish: 'coinsurance',
    },
    coinsuranceTitleText: {
        english: 'Coinsurance',
        spanish: 'Coinsurance',
    },
    youPayText: {
        english: 'You pay',
        spanish: 'You pay',
    },
    deductibleAppliesText: {
        english: 'Deductible applies',
        spanish: 'Deductible applies',
    },
    planMaximumsText: {
        english: 'Plan maximums',
        spanish: 'Plan maximums',
    },
    individualAnnualText: {
        english: 'Individual annual used to date',
        spanish: 'Individual annual used to date',
    },
    indvidualLifetimeText: {
        english: 'Individual lifetime ortho used to date',
        spanish: 'Individual lifetime ortho used to date',
    },
    planMaximumsAnnualText: {
        english: 'For Preventative, Basic, & Major Services Combined',
        spanish: 'For Preventative, Basic, & Major Services Combined',
    },
    deductibleAndCoinsuranceNotFoundWarning: {
        english: `We're sorry for the inconvenience, but we are unable to provide deductible and coinsurance information for this plan. Please contact us for further assistance.`,
        spanish: `We're sorry for the inconvenience, but we are unable to provide deductible and coinsurance information for this plan. Please contact us for further assistance.`,
    },
    generalError: {
        english: 'Error: We are unable to retrieve this information at this time. Please try again later.',
        spanish: 'Error: We are unable to retrieve this information at this time. Please try again later.',
    },
    planOverviewConditionsTitle: {
        english: 'Additional eligibility conditions',
        spanish: 'Additional eligibility conditions',
    },
    IdCardTitle: {
        english: 'ID card',
        spanish: 'ID card',
    },
    IdCardText: {
        english: 'Save your ID card to your downloads folder!',
        spanish: 'Save your ID card to your downloads folder!',
    },
    findADentistTitle: {
        english: 'Find a dentist',
        spanish: 'Find a dentist',
    },
    findADentistText: {
        english: 'Find a local dentist for all your needs!',
        spanish: 'Find a local dentist for all your needs!',
    },
    downloadBenefitsTitle: {
        english: 'Download benefits',
        spanish: 'Download benefits',
    },
    downloadBenefitsTitleSmallest: {
        english: 'Benefits',
        spanish: 'Benefits',
    },
    findADentistTitleSmallest: {
        english: 'Dentist',
        spanish: 'Dentist',
    },
    downloadBenefitsText: {
        english: 'Download, print, or save your benefits here!',
        spanish: 'Download, print, or save your benefits here!',
    },
    benefitsPdfError: {
        english: 'There was a problem downloading the benefits PDF. Please try again.',
        spanish: 'There was a problem downloading the benefits PDF. Please try again.',
    },
    idCardPdfError: {
        english: 'There was a problem downloading the ID Card. Please try again.',
        spanish: 'There was a problem downloading the ID Card. Please try again.',
    },
    claimDetailsPdfError: {
        english: 'There was a problem downloading the claim details PDF. Please try again.',
        spanish: 'There was a problem downloading the claim details PDF. Please try again.',
    },
    preventiveServices: {
        english: 'Preventive Services',
        spanish: 'Preventive Services',
    },
    basicServices: {
        english: 'Basic Services',
        spanish: 'Basic Services',
    },
    majorServices: {
        english: 'Major Services',
        spanish: 'Major Services',
    },
    orthodontia: {
        english: 'Orthodontia',
        spanish: 'Orthodontia',
    },
    details: {
        english: 'Details',
        spanish: 'Details',
    },
    frequency: {
        english: 'Frequency',
        spanish: 'Frequency',
    },
    ageLimit: {
        english: 'Age limit',
        spanish: 'Age limit',
    },
    additionalInfo: {
        english: 'Additional Information',
        spanish: 'Additional Information',
    },
    additionalResources: {
        english: 'Additional resources',
        spanish: 'Additional resourcess',
    },
    additionalResourcesForms: {
        english: 'Forms',
        spanish: 'Forms',
    },
    disclaimerTextPlanFundingAddition: {
        english: ' If there are differences between this information and the policy, the terms of the policy control.',
        spanish: ' If there are differences between this information and the policy, the terms of the policy control.',
    },
    hipaaDisclaimer: {
        english: 'Due to HIPAA privacy regulations, information about a spouse or adult dependent dental claim cannot be provided to a member without appropriate authorization. To obtain this information, a spouse or adult dependent can contact us directly.',
        spanish: 'Due to HIPAA privacy regulations, information about a spouse or adult dependent dental claim cannot be provided to a member without appropriate authorization. To obtain this information, a spouse or adult dependent can contact us directly.',
    },
    obtainDisclaimerText: {
        english: 'For a member to obtain this information: ',
        spanish: 'For a member to obtain this information: ',
    },
    authorizationFormDisclaimer: {
        english: 'If Lincoln has a valid authorization form on file (dated within the last 24 months), you may contact us and obtain information about the dependent.',
        spanish: 'If Lincoln has a valid authorization form on file (dated within the last 24 months), you may contact us and obtain information about the dependent.',
    },
    dentalInfoReleaseDisclaimerA: {
        english: 'If Lincoln does not have a valid authorization form on file, the dependent must complete the ',
        spanish: 'If Lincoln does not have a valid authorization form on file, the dependent must complete the ',
    },
    dentalInfoReleaseFormLinkText: {
        english: 'Authorization for Release of Dental Information',
        spanish: 'Authorization for Release of Dental Information',
    },
    dentalInfoReleaseDisclaimerB: {
        english: ' and forward to Lincoln via e-mail, fax, or direct mail.  Please note: the adult dependent information will not be available online.',
        spanish: ' and forward to Lincoln via e-mail, fax, or direct mail.  Please note: the adult dependent information will not be available online.',
    },
    continuedParticipationDisclaimerA: {
        english: "If using a PPO dentist, it is the employee's responsibility to confirm the dentist's continuing participation in the network associated with the covered employee’s plan at the time of treatment. Not sure of your network? Refer to your ",
        spanish: "If using a PPO dentist, it is the employee's responsibility to confirm the dentist's continuing participation in the network associated with the covered employee’s plan at the time of treatment. Not sure of your network? Refer to your ",
    },
    dentalIdCardLink: {
        english: 'Dental ID card',
        spanish: 'Dental ID card',
    },
    continuedParticipationDisclaimerB: {
        english: ', or contact Customer Service at 800-423-2765.',
        spanish: ', or contact Customer Service at 800-423-2765.',
    },
    waitingPeriodNotFoundError: {
        english: `We're sorry for the inconvenience, but we are unable to provide waiting period information for this plan. Please contact us for further assistance.`,
        spanish: `We're sorry for the inconvenience, but we are unable to provide waiting period information for this plan. Please contact us for further assistance.`,
    },
    waitingPeriodGeneralError: {
        english: `Error: We are unable to provide waiting period information at this time. Please try again later.`,
        spanish: `Error: We are unable to provide waiting period information at this time. Please try again later.`,
    },
    claimDetailsNotFoundError: {
        english: `We're sorry for the inconvenience, but we are unable to provide claim details information for this plan. Please contact us for further assistance.`,
        spanish: `We're sorry for the inconvenience, but we are unable to provide claim details information for this plan. Please contact us for further assistance.`,
    },
    claimDetailsGeneralError: {
        english: 'Error: We are unable to provide claim details information at this time. Please try again later.',
        spanish: 'Error: We are unable to provide claim details information at this time. Please try again later.',
    },
    claimSummaryNotFoundError: {
        english: `We're sorry for the inconvenience, but we are unable to provide claim summary information for this plan. Please contact us for further assistance.`,
        spanish: `We're sorry for the inconvenience, but we are unable to provide claim summary information for this plan. Please contact us for further assistance.`,
    },
    claimSummaryGeneralError: {
        english: 'Error: We are unable to provide claim summary information at this time. Please try again later.',
        spanish: 'Error: We are unable to provide claim summary information at this time. Please try again later.',
    },
    benefitsAndFrequencyGeneralError: {
        english: `Error: We are unable to provide benefits and frequencies information at this time. Please try again later.`,
        spanish: `Error: We are unable to provide benefits and frequencies information at this time. Please try again later.`,
    },
    benefitsAndFrequencyNotFoundError: {
        english: `We're sorry for the inconvenience, but we are unable to provide benefits and frequencies information for this plan. Please contact us for further assistance.`,
        spanish: `We're sorry for the inconvenience, but we are unable to provide benefits and frequencies information for this plan. Please contact us for further assistance.`,
    },
    claimsForText: {
        english: 'For ',
        spanish: 'For '
    },
    downloadClaimDetailsText: {
        english: 'Download claim details',
        spanish: 'Download claim details',
    },
    hipaaViolationText: {
        english: 'Due to HIPAA privacy regulations, information about adult dependent\'s claims cannot be provided without appropriate authorization. To obtain this information, the adult dependent must complete the %%link%% and forward to Lincoln via e-mail, fax, or direct mail or call 800-423-2765. Please note: the adult dependent information will not be available online.',
        spanish: 'Due to HIPAA privacy regulations, information about adult dependent\'s claims cannot be provided without appropriate authorization. To obtain this information, the adult dependent must complete the %%link%% and forward to Lincoln via e-mail, fax, or direct mail or call 800-423-2765. Please note: the adult dependent information will not be available online.',
    },
    claimDetails: {
        english: 'View details',
        spanish: 'View details',
    },
    claimsNotFoundInfo: {
        english: 'There are no recent claims at this time.',
        spanish: 'There are no recent claims at this time.',
    },
    dentalConnectInformation: {
        english: 'Access the latest dental health news, estimate the average cost of a dental procedure or ask a dentist a question.',
        spanish: 'Access the latest dental health news, estimate the average cost of a dental procedure or ask a dentist a question.',
    },
    formsInformation: {
        english: 'Access forms related to your dental benefits.',
        spanish: 'Access forms related to your dental benefits.',
    },
    subClaim: {
        english: 'sub claim',
        spanish: 'sub claim'
    }
};
export default DentalText;
